import React from 'react';
import { useNavigate } from 'react-router-dom';

import { CircularProgress, Stack, TextField } from '@mui/material';

import { Root, StyledHeading, StyledTypography } from '../components/styles/styles';
import StyledLink from '../components/styles/StyledLink';
import StyledSection from '../components/styles/StyledSection';
import { StyledButton, StyledButtonGroup } from '../components/styles/StyledButtons';

function ForgotPasswordWrapper(props: BaseForgotPasswordProps) {
  const navigate = useNavigate();
  return <ForgotPassword navigate={navigate} {...props} />;
}

interface BaseForgotPasswordProps {
  forwardUrl?: string;
  email?: string;
}

interface ForgotPasswordProps extends BaseForgotPasswordProps {
  navigate?: (path: string) => void;
}

interface State {
  email: string;
  error: string | null;
  submitting: boolean;
}

class ForgotPassword extends React.Component<ForgotPasswordProps, State> {
  constructor(props: ForgotPasswordProps) {
    super(props);
    this.state = {
      email: props.email || '',
      error: null,
      submitting: false,
    };
  }

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ email: event.target.value });
  };

  handleForgotPassword = () => {};

  render() {
    const { email, error, submitting } = this.state;

    return (
      <Root>
        <StyledSection tone="tone1">
          <StyledHeading>Reset Password</StyledHeading>
          <StyledHeading headerVariant="subheading">
            Enter your email address and we’ll send you a link to reset your password.
          </StyledHeading>
          <form onSubmit={this.handleForgotPassword}>
            <Stack spacing={2}>
              <TextField
                name="email"
                type="email"
                value={email}
                onChange={this.handleChange}
                label="Email"
                fullWidth
                required
              />
              {error && <StyledTypography color="error">{error}</StyledTypography>}
              <StyledButtonGroup>
                <StyledButton type="submit" disabled={submitting}>
                  {submitting ? (
                    <CircularProgress size={24} style={{ marginRight: '0.5rem' }} />
                  ) : (
                    'Reset Password'
                  )}
                </StyledButton>
              </StyledButtonGroup>
              <StyledTypography variant="body2" align="center">
                Remembered your password?{' '}
                <StyledLink tone="default" href="/login">
                  Login Here.
                </StyledLink>
              </StyledTypography>
            </Stack>
          </form>
        </StyledSection>
      </Root>
    );
  }
}

export default ForgotPasswordWrapper;
